import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class PackVerification_ds_get_serialnumber_by_shippingContainerId_serialNumberCodeService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { shippingContainerId: number, serialNumberCode: string }): 
  Promise<{ result: { Id?: number, LookupCode?: string, PackagingId?: number, Lot?: { Id?: number, MaterialId?: number, VendorLotId?: number } } }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.shippingContainerId)) {
      missingRequiredInParams.push('\'shippingContainerId\'');
    }
    if (isNil(inParams.serialNumberCode)) {
      missingRequiredInParams.push('\'serialNumberCode\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/PackVerification/datasources/ds_get_serialnumber_by_shippingContainerId_serialNumberCode/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      shippingContainerId: number, serialNumberCode: string    }) {
        if(isNil(inParams.shippingContainerId)) {
          return true; 
        }
        if(isNil(inParams.serialNumberCode)) {
          return true; 
        }
      return false;
    }
}
